import { Pipe, PipeTransform } from "@angular/core";
import { FullClient, FullClientType } from "@models/full-client.model";

@Pipe({
	name: "fullClientInitiales",
	standalone: true,
})
export class FullClientInitialesPipe implements PipeTransform {
	transform(client: FullClient): string | null {
		const init1 =
			(client.type === FullClientType.PS ? client.ps.prenom : client.remplacant.prenom)
				?.charAt(0)
				?.toUpperCase() || "";
		const init2 =
			(client.type === FullClientType.PS ? client.ps.nom : client.remplacant.nom)?.charAt(0)?.toUpperCase() || "";
		return `${init1}${init2}`.trim() || null;
	}
}
